var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { EmployeeRolesCodes, EmployeeRolesDescription, } from "@/shared/domain/entities/employee";
import { useToast } from "@reverb-ui/react";
var DOCUMENT_TYPE_EMAIL = 148184;
var initialState = {
    loading: false,
    employeesRoles: [],
    getEmployeesRoles: function () { return Promise.resolve(); },
    bindEmployeeWithClient: function () { return Promise.resolve(); },
    unbindEmployeeClient: function () { return Promise.resolve(); },
    bindEmployeeRole: function () { return Promise.resolve(); },
    searchForEmployees: function () { return Promise.resolve([]); },
    createClientEmployee: function () { return Promise.resolve(); },
    employeesSearch: [],
    DEFAULT_ROLES: [],
};
export var UsersTabContext = React.createContext(initialState);
var UsersTabProvider = function (_a) {
    var children = _a.children, entityRepository = _a.entityRepository;
    var toast = useToast();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), employeesRoles = _c[0], setEmployeesRoles = _c[1];
    var _d = useState([]), employeesSearch = _d[0], setEmployeesSearch = _d[1];
    var _e = useState(undefined), toastSuccessMessage = _e[0], setToastSuccessMessage = _e[1];
    var _f = useState(undefined), toastErrorMessage = _f[0], setToastErrorMessage = _f[1];
    useEffect(function () {
        if (toastSuccessMessage) {
            toast({
                status: "success",
                title: toastSuccessMessage,
                duration: 5000,
            });
        }
        if (toastErrorMessage) {
            toast({
                status: "error",
                title: toastErrorMessage,
                duration: 5000,
            });
        }
    }, [toastSuccessMessage, toastErrorMessage, toast]);
    var DEFAULT_ROLES = [
        {
            id: EmployeeRolesCodes.DEFAULT,
            description: EmployeeRolesDescription.DEFAULT,
        },
        {
            id: EmployeeRolesCodes.ADMIN,
            description: EmployeeRolesDescription.ADMIN,
        },
        {
            id: EmployeeRolesCodes.OWNER,
            description: EmployeeRolesDescription.OWNER,
        },
    ];
    var PAGE = 1;
    var filteredEmployeeRoles = function (employeeRoles) {
        return employeeRoles.map(function (employeeRole) {
            var roles = employeeRole.roles;
            var isOwner = roles.find(function (role) { return role.code === EmployeeRolesCodes.OWNER; });
            var isAdmin = roles.find(function (role) { return role.code === EmployeeRolesCodes.ADMIN; });
            if (isOwner) {
                return __assign(__assign({}, employeeRole), { role: {
                        id: EmployeeRolesCodes.OWNER,
                        description: EmployeeRolesDescription.OWNER,
                    } });
            }
            if (isAdmin) {
                return __assign(__assign({}, employeeRole), { role: {
                        id: EmployeeRolesCodes.ADMIN,
                        description: EmployeeRolesDescription.ADMIN,
                    } });
            }
            return __assign(__assign({}, employeeRole), { role: {
                    id: EmployeeRolesCodes.DEFAULT,
                    description: EmployeeRolesDescription.DEFAULT,
                } });
        });
    };
    var getEmployeesRoles = function (clientRockId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            entityRepository
                .getEmployeesByClient(clientRockId)
                .then(function (response) { return setEmployeesRoles(filteredEmployeeRoles(response)); })
                .catch(function (error) { return setToastErrorMessage(error.message); })
                .finally(function () {
                setLoading(false);
                setToastErrorMessage(undefined);
            });
            return [2 /*return*/];
        });
    }); };
    var unbindEmployeeClient = function (clientRockId, employeeRockId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            entityRepository
                .unbindEmployee({
                rockId: clientRockId,
                employeeRockId: employeeRockId,
            })
                .then(function () {
                setToastSuccessMessage("User successfully unassigned");
            })
                .catch(function (error) { return setToastSuccessMessage(error.message); })
                .finally(function () {
                getEmployeesRoles(clientRockId);
                setToastSuccessMessage(undefined);
                setToastErrorMessage(undefined);
            });
            return [2 /*return*/];
        });
    }); };
    var bindEmployeeRole = function (clientRockId, employeeRockId, role) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            entityRepository
                .addEmployeeRole({
                employeeRockId: employeeRockId,
                role: role,
                rockId: clientRockId,
            })
                .then(function () {
                setToastSuccessMessage("Role successfully updated");
            })
                .catch(function (error) { return setToastErrorMessage(error.message); })
                .finally(function () {
                getEmployeesRoles(clientRockId);
                setToastSuccessMessage(undefined);
                setToastErrorMessage(undefined);
            });
            return [2 /*return*/];
        });
    }); };
    var bindEmployeeWithClient = function (clientRockId, employeeRockId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            entityRepository
                .bindEmployee({
                employeeRockId: employeeRockId,
                rockId: clientRockId,
            })
                .then(function () {
                setToastSuccessMessage("User successfully assigned");
            })
                .catch(function (error) { return setToastErrorMessage(error.message); })
                .finally(function () {
                getEmployeesRoles(clientRockId);
                setToastSuccessMessage(undefined);
                setToastErrorMessage(undefined);
                setEmployeesSearch([]);
            });
            return [2 /*return*/];
        });
    }); };
    var searchForEmployees = function (search, limit) { return __awaiter(void 0, void 0, void 0, function () {
        var searchResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, entityRepository.getEntities({
                        search: search,
                        page: PAGE,
                        limit: limit,
                    })];
                case 1:
                    searchResponse = _a.sent();
                    setEmployeesSearch(searchResponse);
                    return [2 /*return*/, searchResponse];
            }
        });
    }); };
    var createEmployee = function (clientRockId, email, locationId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            entityRepository
                .createCompanyEmployee(clientRockId, {
                name: email,
                locationId: locationId,
                documentTypeId: DOCUMENT_TYPE_EMAIL,
                document: email,
                user: {
                    email: email,
                },
            })
                .then(function () {
                setToastSuccessMessage("Employee successfully created");
            })
                .catch(function (error) { return setToastErrorMessage(error.message); })
                .finally(function () {
                getEmployeesRoles(clientRockId);
                setToastSuccessMessage(undefined);
                setToastErrorMessage(undefined);
                setEmployeesSearch([]);
            });
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(UsersTabContext.Provider, { value: {
            loading: loading,
            employeesRoles: employeesRoles,
            getEmployeesRoles: getEmployeesRoles,
            unbindEmployeeClient: unbindEmployeeClient,
            bindEmployeeRole: bindEmployeeRole,
            searchForEmployees: searchForEmployees,
            employeesSearch: employeesSearch,
            DEFAULT_ROLES: DEFAULT_ROLES,
            bindEmployeeWithClient: bindEmployeeWithClient,
            createClientEmployee: createEmployee,
        } }, children));
};
export default UsersTabProvider;
